import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'

import {
  selectAllDashboardFolders,
  selectAvailableDashboardFolders,
  selectDashboardFoldersFetched,
  selectOneDashboardFolder
} from 'redux/selectors/DashboardFolders'

export const useDashboardFolder = (id?: string) => {
  return useSelector((state: ApplicationState) =>
    selectOneDashboardFolder(state, id)
  )
}

export const useDashboardFolders = () => {
  return useSelector(selectAllDashboardFolders)
}

/**
 * Get dashboard folders fetched state.
 * Returns true if dashboard folders have been fetched.
 * @returns boolean - true if fetched
 */
export const useDashboardFoldersFetched = () => {
  return useSelector(selectDashboardFoldersFetched)
}

/**
 * Get available dashboard folders based on user permissions.
 * - Admins/Homepal users: See all folders
 * - Regular users: See only folders with accessible dashboard groups
 * - Folder updated_at is overridden with latest dashboard group update
 * @returns Array of available folders sorted alphabetically
 */
export const useAvailableDashboardFolders = () => {
  return useSelector(selectAvailableDashboardFolders)
}
